import { Dispatch, SetStateAction, useCallback } from 'react';
import { Button } from '@global-ecom/nitro-uds/elements';

type ProductVideoMuteButtonProps = {
  isMuted?: boolean;
  setIsMuted: Dispatch<SetStateAction<boolean>>;
  className: string;
};

export const ProductVideoMuteButton = ({
  isMuted,
  setIsMuted,
  className,
}: ProductVideoMuteButtonProps) => {
  const handleVideoMute = useCallback(
    event => {
      event.stopPropagation();
      setIsMuted(!isMuted);
    },
    [setIsMuted, isMuted]
  );
  return (
    <Button
      onClick={handleVideoMute}
      className={className}
      label={isMuted ? 'muted' : 'unmuted'}
      icon={isMuted ? 'volume-off' : 'volume-on'}
      mode="icon"
    />
  );
};
